var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrgAvatarUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 9.5,
    r: 7.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 2C7.35866 2 4 5.35866 4 9.5C4 13.6413 7.35866 17 11.5 17C15.6413 17 19 13.6413 19 9.5C19 5.35866 15.6413 2 11.5 2ZM15.1872 7.8324L11.1078 11.9134C10.9721 12.0492 10.7927 12.1179 10.6151 12.1179C10.4358 12.1179 10.2581 12.0492 10.1223 11.9134L7.81285 9.60559C7.70726 9.5 7.65028 9.36089 7.65028 9.21173C7.65028 9.06257 7.70894 8.92346 7.81285 8.81788C8.03073 8.6 8.38436 8.6 8.60056 8.81788L10.6134 10.8307L14.3994 7.04469C14.6173 6.82682 14.9693 6.82682 15.1872 7.04469C15.2927 7.15028 15.3497 7.28939 15.3497 7.43855C15.3514 7.58771 15.2927 7.72682 15.1872 7.8324V7.8324Z",
    fill: "#00C087"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrgAvatarUpload);
export default __webpack_public_path__ + "static/media/org-avatar-upload.05163fade259496435ee19ae7d1632d7.svg";
export { ForwardRef as ReactComponent };